import React from "react";
import Player from "./Player";
import ToRateList from "./ToRateList";
import PlaylistList from "./PlaylistList";
import SearchPane from "./SearchPane";
import MyRatings from "./MyRatings";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Route } from "react-router-dom";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import SnobifyStore from "../store/SnobifyStore";
import TagList from "./TagList";
import Admin from "./Admin";

const useStyles = (theme) => ({
  mainContent: {
    minHeight: "75vh",
  },
  title: {
    flexGrow: 1,
  },
  spaceBelow: {
    marginBottom: theme.spacing(1),
  },
  link: {
    textDecoration: "none",
  },
});

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideBarOpen: true,
      searchString: "",
      throttledSearchString: "",
      store: new SnobifyStore(),
    };
  }

  toggleSidebarOpen = () => {
    this.setState((prevState) => {
      return { sideBarOpen: !prevState.sideBarOpen };
    });
  };

  setCurrentlyPlayingTrack = (trackID, isCurrentlyPaused) => {
    this.setState({
      currentlyPlayingTrack: trackID,
      isCurrentlyPaused: isCurrentlyPaused,
    });
  };

  setSearchString = async (searchString) => {
    this.setState({ searchString: searchString });
    await this.updateThrottledSearchString();
  };

  updateThrottledSearchString = AwesomeDebouncePromise(() => {
    this.setState((prevState) => {
      return {
        throttledSearchString: prevState.searchString,
      };
    });
  }, 1000);

  render() {
    const { sideBarOpen, searchString, throttledSearchString, store } =
      this.state;

    const { classes, handleLogout } = this.props;

    return (
      <Grid container>
        <Header handleLogout={handleLogout} />
        <Grid item xs={sideBarOpen ? 3 : 1}>
          <Sidebar
            isOpen={sideBarOpen}
            toggleSidebarOpen={this.toggleSidebarOpen}
            searchString={searchString}
            setSearchString={this.setSearchString}
          />
        </Grid>
        <Grid item xs={sideBarOpen ? 9 : 11} className={classes.mainContent}>
          <Route path="/admin" render={(_) => <Admin store={store} />} />
          <Route path="/ratings" render={(_) => <MyRatings store={store} />} />
          <Route
            path="/search"
            render={(_) => (
              <SearchPane searchString={throttledSearchString} store={store} />
            )}
          />
          <Route path="/playlists" render={(_) => <PlaylistList />} />
          <Route path="/tags" render={(_) => <TagList store={store} />} />
          <Route
            exact
            path={["/albums_to_rate", "/"]}
            render={(_) => <ToRateList store={store} />}
          />
        </Grid>
        <Grid item xs={12}>
          <Player store={store} />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(Dashboard);
